<template>
  <el-form
    ref="loginByCode"
    status-icon
    :model="loginForm"
    :rules="loginRules"
    class="login-form"
    autocomplete="on"
    label-position="left"
  >
    <el-form-item prop="phoneNumber">
      <el-input
        ref="username"
        v-model="loginForm.phoneNumber"
        placeholder="请输入手机号码"
        name="username"
        type="text"
        tabindex="1"
        autocomplete="on"
      >
        <template slot="prepend">
          <svg-icon icon-class="mobile" class="phone-icon" />
        </template>
      </el-input>
    </el-form-item>

    <el-form-item prop="code" style="margin: 40px 0 66px 0">
      <el-input v-model="loginForm.code" style="width:300px" />
      <code-com
        style="float: right;"
        :deviceID="loginForm.phoneNumber"
        :phoneNum="loginForm.phoneNumber"
        businessType="login"
      ></code-com>
    </el-form-item>
    <el-button
      type="primary"
      class="login-button"
      @click.native.prevent="verifyLoginForm('loginByCode')"
    >登录</el-button>
  </el-form>
</template>

<script>
import code from "@/components/code/code";

import mixin from "./mixin";
export default {
  mixins: [mixin],

  components: {
    "code-com": code
  },

  data() {
    return {
      capsTooltip: true,
      passwordType: "password"
    };
  },

  computed: {
    passwordRules() {
      return this.loginRules;
    }
  },

  methods: {
    async handleLogin() {
      const loginData = {
        phoneNum: this.loginForm.phoneNumber,
        code: this.loginForm.code,
        deviceID: this.loginForm.phoneNumber,
        type: "mobile"
      };

      await this.$api.loginByCode(loginData);

      this.loginSuccess();
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .phone-icon {
  font-size: 16px;
  font-weight: 400;
}

.login-button {
  width: 100%;
  margin-bottom: 25px;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 25px;
}
</style>

